<div class="setting-page">
  <legend>Calls</legend>
  <arm-form (submitForm)="submit()"  [disableSubmit]="!canSubmit">
    <arm-form-title>CALLS Values</arm-form-title>
    <div class="settings-section">
        <p>
        <mat-checkbox [(ngModel)]="callsSettings.enabled" name="enabled"
                      [ngModelOptions]="{standalone: true}"
                      color="primary">
          Enable CDR calls
        </mat-checkbox>
        </p>
        <p>
        <mat-checkbox [(ngModel)]="callsSettings.includeCdrInPartialCalls" name="includeCdrInPartialCalls"
                      [ngModelOptions]="{standalone: true}"
                      color="primary">
          Keep raw CDRs for calls with partial data
        </mat-checkbox>
        </p>
        <p>
        <mat-checkbox [(ngModel)]="callsSettings.includeCdrInSuccessfulCalls" name="includeCdrInSuccessfulCalls"
                      [ngModelOptions]="{standalone: true}"
                      color="primary">
          Keep raw CDRs for calls with full data
        </mat-checkbox>
        </p>


        <p>
        <mat-form-field class="halfWidth">
          <mat-label>Number of CDR calls limit</mat-label>
          <input type="number" [(ngModel)]="callsSettings.limit" matInput name="limit"  [min]="minCdrCalls" [max]="maxCdrCalls" required>
          <mat-error>
            value range between {{minCdrCalls}} to {{maxCdrCalls}}
          </mat-error>
        </mat-form-field>
        </p>
        <p>
        <mat-form-field class="halfWidth">
          <mat-label>Calls cleanup frequency (in minutes) </mat-label>
          <input type="number" [(ngModel)]="callsSettings.removeDueToCountDateScheduler" matInput name="removeDueToCountDateScheduler"  [min]="minCleanupFrequencyCalls"
                 [max]="maxCleanupFrequencyCalls" required>
          <mat-error>
            value range between {{minCleanupFrequencyCalls}} to {{maxCleanupFrequencyCalls}}
          </mat-error>
        </mat-form-field>
        </p>
        <p>
        <mat-form-field class="halfWidth">
          <mat-label>Number of days to keep calls information</mat-label>
          <input type="number" [(ngModel)]="callsSettings.historyDays" matInput name="historyDays"  [min]="minHistoryDays" [max]="maxHistoryDays" required>
          <mat-error>
            value range between {{minHistoryDays}} to {{maxHistoryDays}}
          </mat-error>
        </mat-form-field>
        </p>

        <p>
          <mat-label>*Calls cleanup frequency change will take place after restart</mat-label>
        </p>
    </div>
  </arm-form>
</div>
